export const dominantColors = [
  "#FF6A6A",
  "#0DAB76",
  "#00E5E8",
  "#5C5D8D",
  "#99B2DD",
  "#9381FF",
  "#B8B8FF",
]; // list of dominant colors for the tags
